import { SchemaFormHook } from "@/components/form";
import { Drawer, DrawerProps, ModalHeader } from "@/components/modal";
import { AddCajaMovimientoMutation } from "@/features/cajas/caja-actual/api/add-caja-movimiento";
import AddCajaMovimientoForm, { addCajaMovimientoFormSchema } from "@/features/cajas/caja-actual/components/add-caja-movimiento-form";
import useMonetizacion from "@/features/monetizacion/hooks/use-monetizacion";
import { notify } from "@/shared/notification";

export default function AddCajaMovimientoModal({ ...props }: DrawerProps) {
    const { transferenciaMetodos } = useMonetizacion();

    return <Drawer {...props}>
        <ModalHeader>Nuevo Movimiento</ModalHeader>
        <AddCajaMovimientoMutation>
            {mutation => <SchemaFormHook
                schema={addCajaMovimientoFormSchema}
                onSubmit={async ({ value }) => {
                    await mutation.mutateAsync(value);
                    notify("El movimiento se a guardado correctamente.")
                }}
                defaultValues={{
                    transferencia: {
                        items: transferenciaMetodos.filter(tm => !tm.hidden).map(tm => ({
                            transferenciaMetodoId: tm.id,
                            monto: { items: [] }
                        }))
                    }
                }}
                submitOnce
                closeModalOnSubmit
            >
                {form => <AddCajaMovimientoForm form={form} padding={3} />}
            </SchemaFormHook>}
        </AddCajaMovimientoMutation>
    </Drawer>
}